module.exports = __webpack_public_path__ + "static/oc_baner-c8c11a88f096cdda05bd898748fae877.png";